import React, { useState, useRef, useEffect } from 'react';
// import Logo from '../../assets/icons/gardenwall/prtc.png';
import Logo from '../../assets/icons/gardenwall/archtopfiber-logo_color.png';
import Pic1 from '../../assets/icons/gardenwall/sidebar-bot.png';
import Dashboard from './Dashboard/Dashboard';
import InvoiceAndPayments from './InvoiceAndPayments/InvoiceAndPayments';
import UsageAnalysis from './UsageAnalysis/UsageAnalysis';
import MyAccount from './MyAccount/MyAccount';
import Support from './Support/Support';
import Documents from './Documents/Documents';
import Notifications from './Notifications/Notifications';
import Services from './Services/Services';
import './GardenWallApp.css';
import SubscriberHeader from './Dashboard/components/Header/Header';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';
import {
  getScenarioContent,
  getTemplatePrefix,
} from './Constants/paymentScenarios';
import {
  COMPANY_API_CUSTOMER_ID,
  CUSTOMER_NAME,
  COMPANY_CONFIG
} from '../../constants/companyConfig';
/**
 * Sidebar Component
 */
const Sidebar = ({
  activePage,
  onSelectMenuItem,
  toggles,
  handleToggle,
  paymentScenario,
}) => {
  // Use scenario content for styling
  const scenarioContent = getScenarioContent(paymentScenario);

  const menuItems = [
    {
      key: 'dashboard',
      icon: 'home.svg',
      title: 'Dashboard',
      toggleKey: 'showDashboard',
    },
    {
      key: 'invoice',
      icon: 'Receipt-Check.svg',
      title: 'Invoice and Payments',
      toggleKey: 'showInvoice',
    },
    {
      key: 'services',
      icon: 'services.svg',
      title: 'Services',
      toggleKey: 'showServices',
    },
    {
      key: 'usage',
      icon: 'Graph--Streamline-Core.svg',
      title: 'Usage Analysis',
      toggleKey: 'showUsage',
    },
    {
      key: 'documents',
      icon: 'documents.svg',
      title: 'Documents',
      toggleKey: 'showDocuments',
    },
    {
      key: 'support',
      icon: 'support.svg',
      title: 'Support',
      toggleKey: 'showSupport',
    },
    {
      key: 'account',
      icon: 'User-Circle.svg',
      title: 'My Account',
      toggleKey: 'showAccount',
    },
    {
      key: 'notifications',
      icon: 'bell-0.svg',
      title: 'Notifications',
      toggleKey: 'showNotifications',
    },
  ];

  // if (CUSTOMER_NAME.toLowerCase() === 'prtc') {
  //   Logo = require('../../assets/icons/gardenwall/prtc.png');
  // } else if (CUSTOMER_NAME.toLowerCase() === 'archtop fiber') {
  //   Logo = require('../../assets/icons/gardenwall/archtopfiber-logo_color.png');
  // }  else {
  //   //Logo = require('../../../assets/images/default-logo.png');
  // }

   const domain = COMPANY_CONFIG.domain;
    
    if (domain === 'prtc') {
      Logo = require('../../assets/images/prtc-logo.png');
    } else if (domain === 'archtop') {
      Logo = require('../../assets/images/archtopfiber-logo_color.png');
    } else if (domain === 'highline') {
        Logo = require('../../assets/images/highline.png');
      } else if (domain === 'interbel') {
      Logo = require('../../assets/images/interbel-logo.png');
    } else if (domain === 'acs') {
        Logo = require('../../assets/images/akcs-logo.png');
      } else if (domain === 'cwf') {
          Logo = require('../../assets/images/clear-wave.png');
        }else {
      //logo = require('../../../assets/images/default-logo.png');
    }

  return (
    <div className="garden-wall-sidebar">
      <div className="garden-wall-sidebar-header">
        <img
  width={200}
  src={Logo}
  alt="Logo"
  className="sidebar-logo"
  style={
    domain === 'acs'
      ? { height: '70px' }
      : (domain === 'interbel' || domain === 'highline')
      ? { height: '50px' }
      : {}
  }
/>

        {/* Payment Scenario Status Indicator */}
        {paymentScenario && (
          <div className="scenario-status-indicator">
            {/*<span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>*/}
          </div>
        )}
      </div>
      <ul className="garden-wall-sidebar-menu">
        {menuItems.map((item) => {
          let imagePath;
          try {
            imagePath = require(`../../assets/icons/gardenwall/${item.icon}`);
          } catch (error) {
            imagePath = require(`../../assets/icons/gardenwall/exm.svg`);
          }
          return (
            <li
              key={item.key}
              className={`menu-item ${activePage === item.key ? 'menu-item-active' : ''} ${
                !toggles[item.toggleKey] ? 'menu-item-disabled' : ''
              }`}
            >
              <div
                className="menu-content"
                onClick={() =>
                  toggles[item.toggleKey] && onSelectMenuItem(item.key)
                }
              >
                <span className="menu-icon">
                  <img src={imagePath} alt={item.title} />
                </span>
                <span className="menu-title">{item.title}</span>
              </div>
              {/* Show toggle only if NOT Dashboard */}
              {item.key !== 'dashboard' && (
                <div className="menu-item-toggle">
                  <div
                    className="custom-toggle"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggle(item.toggleKey);
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={toggles[item.toggleKey]}
                      readOnly
                    />
                    <span className="toggle-slider"></span>
                  </div>
                </div>
              )}
            </li>
          );
        })}
      </ul>

      {/* Removed separate settings panel as toggles are now inline */}

      {/* <div className="garden-wall-sidebar-footer">
        <div
          style={{ position: 'relative', paddingTop: '30px' }}
          className={`paperless-container ${
            !toggles.stopPaperBill ? 'card-disabled' : ''
          }`}
        >
          <div
            className="paperless-toggle"
            style={{ position: 'absolute', right: 0, top: 0 }}
          >
            <div
              className="custom-toggle"
              onClick={() => handleToggle('stopPaperBill')}
            >
              <input type="checkbox" checked={toggles.stopPaperBill} readOnly />
              <span className="toggle-slider"></span>
            </div>
          </div>
          <img
            src={Pic1}
            width={200}
            alt="Go Green Banner"
            className="paperless-banner"
          />
        </div>
      </div> */}
    </div>
  );
};

/**
 * GardenWallApp Wrapper
 */
const GardenWallApp = ({ activeData }) => {
  const { token } = useAuth();
  const [activePage, setActivePage] = useState('dashboard');

  const paymentScenario = activeData || null;
  console.log('GardenWallApp - Received paymentScenario:', paymentScenario);

  // Use constants for scenario handling
  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  console.log('GardenWallApp activeData:', activeData);
  console.log('GardenWallApp scenarioPrefix:', scenarioPrefix);

  // State for toggles - including menu visibility toggles
  const [toggles, setToggles] = useState({
    stopPaperBill: true,
    showDashboard: true,
    showInvoice: true,
    showServices: true,
    showUsage: true,
    showDocuments: true,
    showSupport: true,
    showAccount: true,
    showNotifications: true,
  });

  const [templates, setTemplates] = useState([]);
  const [blockStates, setBlockStates] = useState({});
  const triggerSaveData = useRef(false);
  const [reloadTemplates, setReloadTemplates] = useState(false);

  // Template name logic with scenario prefix - matching other components
  const template_name =
    scenarioPrefix === 'current-payment'
      ? 'gardenwall-sidebar'
      : `gardenwall-sidebar-${scenarioPrefix}`;

  console.log('GardenWallApp Template name:', template_name);

  const handleBlockStatesChange = (newBlockStates) => {
    setBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  // Function to toggle on/off switches - matching other components
  const handleToggle = (section) => {
    setToggles((prev) => ({ ...prev, [section]: !prev[section] }));
    triggerSaveData.current = true;
  };

  // Auto-save trigger - matching other components pattern
  useEffect(() => {
    if (triggerSaveData.current) {
      saveData();
      triggerSaveData.current = false;
    }
  }, [toggles, blockStates]);

  // Fetch templates function - matching other components
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  // Load templates on mount - matching other components
  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };

    loadTemplates();
  }, []);

  // Reload templates effect - matching other components
  useEffect(() => {
    if (reloadTemplates) {
      const loadTemplates = async () => {
        const fetchedTemplates = await fetchTemplates();
        setTemplates(fetchedTemplates);
        setReloadTemplates(false);
      };

      loadTemplates();
    }
  }, [reloadTemplates]);

  // Apply template data when templates are loaded - matching other components
  useEffect(() => {
    if (templates && templates.length > 0) {
      console.log('GardenWallApp Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          setToggles(
            template_data.toggles || {
              stopPaperBill: true,
              showDashboard: true,
              showInvoice: true,
              showServices: true,
              showUsage: true,
              showDocuments: true,
              showSupport: true,
              showAccount: true,
              showNotifications: true,
            }
          );
          setBlockStates(template_data.blockStates || {});
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        console.log('GardenWallApp specific template not found');
      }
    }
  }, [templates, template_name]);

  // Save data function - matching other components pattern
  const saveData = async () => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles,
        blockStates,
        scenarioData: paymentScenario,
      })
    );

    console.log('GardenWallApp - Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    if (templates && templates.length > 0) {
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate && specificTemplate.id) {
        url = `${urlBase}/update/${specificTemplate.id}`;
        method = 'put';
      }
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('GardenWallApp Response Data:', response.data);
      if (method === 'post') {
        setReloadTemplates(true);
      }
    } catch (error) {
      console.error('Error saving sidebar template:', error);
    }
  };

  const renderContent = () => {
    switch (activePage) {
      case 'dashboard':
        return <Dashboard activeData={activeData} />;
      case 'invoice':
        return <InvoiceAndPayments activeData={activeData} />;
      case 'services':
        return <Services activeData={activeData} />;
      case 'usage':
        return <UsageAnalysis activeData={activeData} />;
      case 'documents':
        return <Documents activeData={activeData} />;
      case 'support':
        return <Support activeData={activeData} />;
      case 'account':
        return <MyAccount activeData={activeData} />;
      case 'notifications':
        return <Notifications activeData={activeData} />;
      default:
        return <Dashboard activeData={activeData} />;
    }
  };

  return (
    <div className="gardenwall-layout">
      <Sidebar
        activePage={activePage}
        onSelectMenuItem={setActivePage}
        toggles={toggles}
        handleToggle={handleToggle}
        paymentScenario={paymentScenario}
      />
      <div className="garden-wall-content">
        <SubscriberHeader />
        {renderContent()}
      </div>
    </div>
  );
};

export default GardenWallApp;
